import {
  MetamodelContextSettings,
  MetamodelFieldContext,
} from 'metamodel/types';
import { APIFieldAttributes, Metamodel } from '@ardoq/api-types';
import { FieldStats } from './fieldStats/FieldStats';
import { type I18nLocale } from '@ardoq/i18n';

const ReferenceFieldStats = ({
  context,
  metamodel,
  isCheckboxField,
  nonTemplateFieldsByName,
  i18nLocale,
}: {
  context: MetamodelFieldContext & MetamodelContextSettings;
  metamodel: Metamodel;
  isCheckboxField: boolean;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  i18nLocale: I18nLocale;
}) => (
  <FieldStats
    context={context}
    metamodel={metamodel}
    isCheckboxField={isCheckboxField}
    nonTemplateFieldsByName={nonTemplateFieldsByName}
    i18nLocale={i18nLocale}
  />
);

export { ReferenceFieldStats };
